import { withTranslate } from '@i18n/utils'

const Checkbox = ({ label, children, className = '', translate: t, ...inputProps }) => {
    const getErrorMessage = event => {
        const errorType = event?.target?.validity

        if (errorType?.valueMissing) {
            return event.target.setCustomValidity(t('checkbox.required.invalid.error.message'))
        }

        return event.target?.setCustomValidity('')
    }

    return (
        <label className={`custom-control custom-checkbox ${className}`}>
            <input className="custom-control-input" type="checkbox" {...inputProps} onInvalid={getErrorMessage} />
            <span className="custom-control-indicator" aria-hidden="true" />
            {label ? (
                <span className="custom-control-description" dangerouslySetInnerHTML={{ __html: label }} />
            ) : (
                <span className="custom-control-description">{children}</span>
            )}
        </label>
    )
}

export default withTranslate(Checkbox)
